<template>
    <div class="d-flex">
        <modal-portal to="top" v-if="canpostprocess">
            <div class="mt-3 mx-auto pr-0 pr-sm-2" style="max-width: 450px">
                <mode-selector :modes="['Offer', 'Automation']" v-model="mode"/>
            </div>
        </modal-portal>

        <div style="width: 350px" class="mx-auto" v-if="mode == 'Offer'">
            <b-alert variant="secondary" :show="action == 'counter'" class="text-center font-weight-bold">Counter Offer
            </b-alert>
            <b-alert variant="success" :show="action == 'accept'" class="h6 text-center font-weight-bold">Accept Offer
            </b-alert>
            <b-alert variant="danger" :show="action == 'decline'" class="h6 text-center font-weight-bold">Decline Offer
            </b-alert>

            <modal-row v-if="!!offer.auction" is-text label="Active Price">
                {{ offer.auction.price | money }}
            </modal-row>

            <modal-row v-if="action == 'counter'" label="Counter Offer">
                <div class="mb-2">
                    <b-input-group :prepend="getSymbolFromCurrency(offer.currency)" :append="offer.currency" size="sm">
                        <form-currency v-model="response.amount" autofocus size="sm" />
                    </b-input-group>
                    <b-form-text v-if="!offer.is_native_currency">Approx
                        {{ response.amount / offer.native_exchange_rate | money }} USD
                    </b-form-text>
                </div>
            </modal-row>

            <template v-if="canpostprocess">
                <modal-row v-if="!!offer.auction" label="Reprice">
                    <div class="mb-3">
                        <b-check class="mt-1 mb-3" v-model="e_reprice" switch>Reprice</b-check>
                        <template v-if="e_reprice">
                            <b-input-group prepend="$" append="USD" size="sm">
                                <form-currency size="sm" title="Reprice To" v-model="reprice.ebay_reprice_to" />
                            </b-input-group>
                            <b-check class="mt-2" switch v-model="reprice.ebay_reprice_bo">Enable Best Offer</b-check>
                        </template>
                    </div>
                </modal-row>

                <modal-row label="Response">
                    <b-textarea v-model="response.response" rows="4"/>
                </modal-row>
            </template>
        </div>
        <div style="max-width: 460px" class="mx-auto" v-if="mode == 'Automation'">
            <auction-automation v-model="rules" :price="offer.auction.price"/>
        </div>

        <modal-portal to="footer">
            <b-btn size="sm" variant="outline-secondary" @click="$emit('cancel')" class="px-3 mr-1">Cancel</b-btn>
            <b-btn size="sm" :variant="{accept: 'success', decline: 'danger', counter: 'secondary'}[action]"
                   class="px-3" @click="process">
                {{ action | ucfirst }}
            </b-btn>
        </modal-portal>
    </div>
</template>

<script>
import AuctionAutomation from "../auction/auction-automation.vue";
import getSymbolFromCurrency from 'currency-symbol-map'

export default {
    name: "offer-action",
    components: {AuctionAutomation},

    props: {
        offer: Object,
        action: String,
    },

    data() {
        return {
            response: {},
            e_reprice: false,
            reprice: {},
            rules: null,
            mode: 'Offer',
            e_rules: false
        }
    },

    computed: {
        canpostprocess() {
            return this.offer.auction && ((this.action == 'counter' || this.action == 'decline') || (this.offer.quantity < this.offer.auction.qty_remaining))
        }
    },

    watch: {
        e_reprice(v) {
            this.reprice = v ? {ebay_reprice_bo: false} : {}
        },

        mode(mode) {
            if (mode == 'Automation')
                this.e_rules = true
        }
    },

    created() {
        if (this.offer.auction)
            this.rules = this.offer.auction.rules || []
    },

    methods: {
        getSymbolFromCurrency: getSymbolFromCurrency,

        async process() {
            if (this.action == 'counter' && parseFloat(this.response.amount) < parseFloat(this.offer.offer_amount_native)) {
              this.alert('Counter less than offer amount.')
              return
            }

            await this.asyncAction(this.offer._links.self_url.href, 'PUT', {
                data: {
                    task: this.action,
                    ...this.response,
                    ...this.reprice,
                }
            })

            this.toast({
                decline: 'Declined',
                accept: 'Accepted',
                counter: 'Countered'
            }[this.action] + ' best offer.')

            try {
                if (this.offer.auction) {
                    let data = {}

                    if (this.action == 'decline' && this.e_reprice)
                        data = {
                            ...data,
                            eb_StartPrice: this.reprice.ebay_reprice_to,
                            eb_BestOfferEnabled: this.reprice.ebay_reprice_bo ? true : false
                        }

                    if (this.e_rules && (this.action == 'decline' || this.action == 'counter'))
                        data = {
                            ...data,
                            rules: this.rules
                        }

                    if (Object.keys(data).length) {
                        await this.asyncAction(this.offer.auction._links.self_url.href, 'PUT', {
                            data
                        })
                        if (this.e_rules)
                            this.toast('Updated listing automation rules.')

                        if (this.e_reprice)
                            this.toast(this.action == 'decline' ? 'Updated active listing price.' : 'Listing will reprice if declined')
                    }
                }
            } finally {
                this.$emit('done')
            }
        }
    }
}
</script>

<style scoped>

</style>